// Carnegie Mellon's undergraduate majors (#2652). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog's Degrees Offered page
// (coursecatalog.web.cmu.edu/degreesoffered/), one tab per college: every
// primary bachelor's degree. Left out: "Additional Major" programs (added to
// a primary major, e.g. Biomedical Engineering, Engineering and Public
// Policy), minors, and the Qatar campus. A joint program the catalog lists
// under two departments or colleges appears once, at its first listing, with
// a note; Music and Technology sits with the School of Music, whose applicant
// page sets its portfolio. The four BXA degrees carry no degree abbreviation
// in the catalog. Flags quote CMU's College of Fine Arts Applicants page (the
// college file's `cfa` source). The KB's majors list was the starting point;
// the catalog wins.
const majors = {
    "slug": "carnegie-mellon-university",
    "read": "2026-10-01",
    "intro": "Every primary undergraduate degree in Carnegie Mellon's 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Additional majors (taken only alongside a primary major), minors, graduate programs and the Qatar campus are left out.",
    "groups": [
        {
            "name": "College of Engineering",
            "source": {
                "label": "Carnegie Mellon Undergraduate Catalog 2026-2027, Degrees Offered, College of Engineering",
                "url": "https://coursecatalog.web.cmu.edu/degreesoffered/"
            },
            "majors": [
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ],
            "note": "You apply to and are admitted directly to a department or major, unless you choose undecided.",
            "noteSource": "requirements"
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "Carnegie Mellon Undergraduate Catalog 2026-2027, Degrees Offered, College of Fine Arts",
                "url": "https://coursecatalog.web.cmu.edu/degreesoffered/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BArch",
                    "flag": "A portfolio of 10 creative works, due with the application for Early Decision or by January 11 for Regular Decision.",
                    "flagSource": "cfa"
                },
                {
                    "name": "Architecture",
                    "degree": "BA",
                    "flag": "A portfolio of 10 creative works, due with the application for Early Decision or by January 11 for Regular Decision.",
                    "flagSource": "cfa"
                },
                {
                    "name": "Art",
                    "degree": "BFA",
                    "flag": "A portfolio of 10 to 20 recent creative works, due with the application for Early Decision or by January 11 for Regular Decision.",
                    "flagSource": "cfa"
                },
                {
                    "name": "Design",
                    "degree": "BDes",
                    "flag": "A portfolio of 10 to 19 slides with a 90-second About Me video, due with the application for Early Decision or by January 11 for Regular Decision.",
                    "flagSource": "cfa"
                },
                {
                    "name": "Drama",
                    "degree": "BFA",
                    "flag": "A separate School of Drama application through Acceptd and a pre-screening by December 1; selected applicants are invited to an audition or interview. No Early Decision.",
                    "flagSource": "cfa"
                },
                {
                    "name": "Composition",
                    "degree": "BFA",
                    "flag": "A separate School of Music application by December 1 with a portfolio of three original compositions and a recording of each. No Early Decision.",
                    "flagSource": "cfa"
                },
                {
                    "name": "Electronic Music",
                    "degree": "BFA",
                    "flag": "A separate School of Music application by December 1 with a portfolio of your electronic music, and an interview with faculty. No Early Decision.",
                    "flagSource": "cfa"
                },
                {
                    "name": "Music Performance",
                    "degree": "BFA",
                    "flag": "A separate School of Music application and a prescreen by December 1; invited applicants audition in February. No Early Decision.",
                    "flagSource": "cfa"
                },
                {
                    "name": "Music and Technology",
                    "degree": "BS",
                    "note": "Jointly with the Department of Electrical and Computer Engineering and School of Computer Science; also listed under College of Engineering",
                    "flag": "A separate School of Music application by December 1: you choose a concentration and submit a portfolio. No Early Decision.",
                    "flagSource": "cfa"
                }
            ],
            "note": "Early Decision is not open to the Schools of Drama and Music, which have a December 1 Regular Decision deadline.",
            "noteSource": "deadlines"
        },
        {
            "name": "Dietrich College of Humanities and Social Sciences",
            "source": {
                "label": "Carnegie Mellon Undergraduate Catalog 2026-2027, Degrees Offered, Dietrich College of Humanities and Social Sciences",
                "url": "https://coursecatalog.web.cmu.edu/degreesoffered/"
            },
            "majors": [
                {
                    "name": "International Relations and Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Political Science, Security, and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Economics and Politics",
                    "degree": "BS"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Film and Visual Media",
                    "degree": "BA"
                },
                {
                    "name": "Literature and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Professional Writing",
                    "degree": "BA"
                },
                {
                    "name": "Technical Writing",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Science, Technology and Society",
                    "degree": "BS"
                },
                {
                    "name": "Ethics, History, and Public Policy",
                    "degree": "BA/BS",
                    "note": "Jointly with the Department of Philosophy"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Global Cultures and Emerging Technologies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Logic and Computation",
                    "degree": "BS"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA/BS"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BS"
                },
                {
                    "name": "Psychology and Biological Sciences",
                    "degree": "BS",
                    "note": "Jointly with the Department of Biological Sciences"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS",
                    "note": "Jointly with the Department of Biological Sciences and the Center for the Neural Basis of Cognition; also listed under Mellon College of Science"
                },
                {
                    "name": "Behavioral Economics",
                    "degree": "BS"
                },
                {
                    "name": "Decision Science",
                    "degree": "BS"
                },
                {
                    "name": "Policy and Management",
                    "degree": "BS"
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Statistics and Data Science (Mathematical Sciences Track)",
                    "degree": "BS"
                },
                {
                    "name": "Statistics and Data Science (Neuroscience Track)",
                    "degree": "BS"
                },
                {
                    "name": "Economics and Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Statistics and Machine Learning",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Mellon College of Science",
            "source": {
                "label": "Carnegie Mellon Undergraduate Catalog 2026-2027, Degrees Offered, Mellon College of Science",
                "url": "https://coursecatalog.web.cmu.edu/degreesoffered/"
            },
            "majors": [
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences and Psychology",
                    "degree": "BS",
                    "note": "Jointly with the Department of Psychology"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry/Biological Chemistry Track",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Mathematical Sciences and Economics",
                    "degree": "BS",
                    "note": "Jointly with the Undergraduate Economics Program"
                },
                {
                    "name": "Computational Finance",
                    "degree": "BS",
                    "note": "Jointly with the Department of Statistics, the H. John Heinz III College, and the Tepper School of Business; also listed under University-Wide, Interdisciplinary, and Joint Degree Programs"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Computer Science",
            "source": {
                "label": "Carnegie Mellon Undergraduate Catalog 2026-2027, Degrees Offered, School of Computer Science",
                "url": "https://coursecatalog.web.cmu.edu/degreesoffered/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Computational Biology",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Human-Computer Interaction",
                    "degree": "BS"
                },
                {
                    "name": "Robotics",
                    "degree": "BS"
                }
            ],
            "note": "The School of Computer Science requires an SAT or ACT score.",
            "noteSource": "tests"
        },
        {
            "name": "David A. Tepper School of Business",
            "source": {
                "label": "Carnegie Mellon Undergraduate Catalog 2026-2027, Degrees Offered, David A. Tepper School of Business",
                "url": "https://coursecatalog.web.cmu.edu/degreesoffered/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Economics and Mathematical Sciences",
                    "degree": "BS",
                    "note": "Jointly with Department of Mathematical Sciences"
                }
            ]
        },
        {
            "name": "University-Wide, Interdisciplinary, and Joint Degree Programs",
            "source": {
                "label": "Carnegie Mellon Undergraduate Catalog 2026-2027, Degrees Offered, University-Wide, Interdisciplinary, and Joint Degree Programs",
                "url": "https://coursecatalog.web.cmu.edu/degreesoffered/"
            },
            "majors": [
                {
                    "name": "Bachelor of Computer Science and Arts",
                    "degree": null,
                    "flag": "You apply through a College of Fine Arts school and complete its portfolio, pre-screen, audition or interview.",
                    "flagSource": "cfa"
                },
                {
                    "name": "Bachelor of Engineering Studies and Arts",
                    "degree": null,
                    "flag": "You apply through a College of Fine Arts school and complete its portfolio, pre-screen, audition or interview.",
                    "flagSource": "cfa"
                },
                {
                    "name": "Bachelor of Humanities and Arts",
                    "degree": null,
                    "flag": "You apply through a College of Fine Arts school and complete its portfolio, pre-screen, audition or interview.",
                    "flagSource": "cfa"
                },
                {
                    "name": "Bachelor of Science and Arts",
                    "degree": null,
                    "flag": "You apply through a College of Fine Arts school and complete its portfolio, pre-screen, audition or interview.",
                    "flagSource": "cfa"
                }
            ]
        }
    ]
};

export default majors;
